export default __webpack_public_path__ + "packages/tables-chooser/react/tables/categories/dimensions/calculation/images/hierarchy-p-and-l-statement.png";